import {WASS} from "../Constantes";

export const iniciarChatWass = ({mensaje='Hola Quesuditas', numero=WASS}) =>{
    let texto = encodeURI(mensaje)
    let link = `https://api.whatsapp.com/send?phone=57${numero}&text=${texto}`
    window.open(link)
}